import { instance } from '../index';
import { isOverseasEnv } from '@/utils/api';

export const logOutUser = async (goId, data, config = {}) => {
  return await instance.post(`/user/realms/${goId}/protocol/openid-connect/logout`, data, config);
};

export const versionPagelist = async (data, config = {}) => {
  const url = isOverseasEnv() ? '/user/version/pagelist' : '/api/admin/version/pagelist';
  return await instance.post(url, data, config);
};

// 海外退出登录
export const overseasLogout = async (data, config) => {
  return await instance.post('/user/auth/logout', data, config);
};
